import React from "react";
import { BigFilledButton, BigOutlineInput } from "components/Base";
import { Label } from "EventLight/Common/FieldLayout";
import MiniModalWrapper from "ui-kit/MiniModalWrapper";
import { AdvancedWYSIWYGWithoutSagas } from "ui-kit/Form/View";
import { MODULES_TINY_MCE, FORMATS_TINY_MCE } from "../constants";
import Tooltip from "ui-kit/Tooltip";

export const LanguageVariantsButton = ({ onClickIcon, tooltip }) => {
  return (
    <Tooltip tooltip={tooltip}>
      <span
        style={{
          fontSize: "15px",
          color: "#4784ed"
        }}
        className="material-icons"
        onClick={onClickIcon}
      >
        public
      </span>
    </Tooltip>
  );
};

const VariantInput = ({ variantType, value, onChange }) => {
  return (
    <div style={{ margin: "12px 0 26px" }}>
      {variantType === "wysiwyg" && (
        <AdvancedWYSIWYGWithoutSagas
          onChange={onChange}
          value={value}
          height={200}
          modules={MODULES_TINY_MCE}
          formats={FORMATS_TINY_MCE}
        />
      )}

      {variantType === "text" && (
        <BigOutlineInput
          value={value}
          onChange={onChange}
          style={{
            width: "100%"
          }}
        />
      )}
    </div>
  );
};

const PreLanguageVariantModal = ({
  toggleLanguageModal,
  languageModalIsOpen,
  translatedValues,
  updateTranslatedValue,
  saveButtonLabel = "Done",
  onSave
}) => {
  return (
    <MiniModalWrapper
      hideModal={() => toggleLanguageModal(false)}
      title="Edit Language Variants"
      display="column.flex-start.stretch"
      width={800}
      showModal={languageModalIsOpen}
    >
      <div
        style={{
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
          width: "100%"
        }}
      >
        <div
          style={{
            padding: "20px 32px",
            overflow: "auto",
            height: "374px"
          }}
        >
          {translatedValues.map(v => {
            return (
              <>
                <Label mb={1}>
                  {v.translated_field_name} ({v.language})
                </Label>

                <VariantInput
                  variantType={v.field_type}
                  value={v.translated_value}
                  onChange={value => {
                    return updateTranslatedValue({
                      fieldId: v.field_id,
                      fieldInternalName: v.field_internal_name,
                      language: v.language,
                      isDefault: v.is_default,
                      value
                    });
                  }}
                />
              </>
            );
          })}
        </div>

        <div
          style={{
            width: "100%",
            height: "70px",
            padding: "10px 32px",
            borderTop: "1px solid #eee"
          }}
        >
          <BigFilledButton
            bg="altB5"
            onClick={() => {
              // onSave(tempVariants);
              if (onSave) {
                onSave();
              } else {
                toggleLanguageModal(false);
              }
            }}
            disabled={false}
          >
            {saveButtonLabel}
          </BigFilledButton>

          {/* <BigOutlineButton
            ml={2}
            onClick={() => {
              toggleLanguageModal(false);
            }}
          >
            Cancel
          </BigOutlineButton>*/}
        </div>
      </div>
    </MiniModalWrapper>
  );
};

export const LanguageVariantModal = PreLanguageVariantModal;
